// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"60444631","935":"a56c737f"}[chunkId] + ".chunk.js";
};